<template>
  <div id="footer" class="container-fluid">
    <div class="wrapper_1200">
      <ul class="list">
        <li>
          <div class="logo">
            <img src="@/assets/img/logo.png" alt="广州华软科技创新有限公司" class="logo">
          </div>
          <p>
            <span style="font-size: large">广州华软科技创新有限公司</span>
          </p>
        </li>
        <li>
          <div class="name">联系我们</div>
          <p class="address_tel_fax">
            <span>企业官网:<a href="/">www.aihrcx.com</a></span>
          </p>
          <p class="address_tel_fax">
            <span>联系手机:13570295967</span>
          </p>
          <p class="address_tel_fax">
            <span>电子邮箱:412106613@qq.com</span>
          </p>
          <p class="address_tel_fax">
            <span>公司地址:广州市白云区广园中路151号4123房K84</span>
          </p>
        </li>
        <li>
          <div class="name">关注我们</div>
          <div class="official">
            <img src="@/assets/img/qrcode.jpg" width="100" />
            <div class="ewm"><span class="iconfont iconxiaochengxu"></span>官方公众号</div>
          </div>
          <div class="official">
            <img src="@/assets/img/wx_qrcode.jpg" width="100" />
            <div class="ewm"><span class="iconfont iconweixin-copy"></span>官方微信</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="clearfix"></div>
<!--    <div class="wrapper_1200">
      <div class="friendship">
        <a>友情链接：</a>
        <a href=""></a>
      </div>
    </div>-->
    <div class="clearfix"></div>
    <div class="copy">
      Copyright © 2025 Powered by <a href="/"> 广州华软科技创新有限公司</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a target="_blank" style="color: #ccc;" href='https://beian.miit.gov.cn'>粤ICP备2025386906号-1</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  bottom: 0;
  width: 100%;
  height: auto; /* 根据内容自动调整高度 */
  z-index: 1000; /* 确保 Footer 在其他内容之上 */
  color: #fff;
  background: #222;
  overflow: hidden;
  text-align: center;
  bottom: 0;
}

.wrapper_1200 {
  width: 1200px;
  margin: 0 auto;
}

.logo {
  width: 60px;
  height: 60px;
  margin: 10px auto 20px;
}

.title {
  font-size: 16px;
  font-weight: bold;
  margin-top: 50px;
  margin-bottom: 20px;
}

.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
  text-align: left;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

@media (min-width: 1200px) {
  .container {
    width: 1170px
  }
}

@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {
    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 40px 0 10px;
  }
}

.list {
  padding-top: 36px;
  width: 1285px;
}

.list li {
  float: left;
  margin-right: 80px;
}

.list li .name {
  color: #fff;
  /*font-weight: bold;*/
  font-size: 16px;
  margin-bottom: 18px;
}

.list li .item {
  font-size: 14px;
  color: #ccc;
  margin-bottom: 10px;
  display: block;
  cursor: pointer;
}

.list li > a:hover {
  color: #fff;
}

.list li > a:hover {
  color: #fff;
}

.list li .item span {
  color: #6aa6ff;
}

.list li .official {
  float: left;
  margin-right: 18px;
}

.list li .official .ewm {
  font-size: 14px;
  color: #ccc;
  text-align: center;
  margin-top: 6px;
}

.list li .official .ewm .iconfont {
  vertical-align: middle;
  margin-right: 5px;
}

.list li .official .ewm .iconfont.iconxiaochengxu {
  font-size: 14px;
}

.friendship {
  border: 1px solid #494d53;
  border-left: 0;
  border-right: 0;
  margin-top: 36px;
  padding: 16px 0;
  font-size: 13px;
  float: left;
}

.friendship > a {
  color: #ccc;
  margin-right: 18px;
  cursor: pointer;
}

.copy {
  width: 1200px;
  margin: 10px auto 20px;
  font-size: 12px;
  color: #ccc;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue